export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const userLabel = (u) => `${u.Name || ''} ${u.LastName || ''}`.trim() || u.Email;

export const agentLabel = (a) => (a.agentName ? `${a.agentName} (${a.agentCode})` : a.agentCode);

// BRANCHNAME → "name (code)" using the Priority BRANCHES list.
export const branchLabel = (code, branchNames) => {
  const name = branchNames?.get(code);
  return name ? `${name} (${code})` : `סניף ${code}`;
};

// Agent→manager rows grouped into one card per manager email, sorted by name.
export const groupByManager = (rows) => {
  const byEmail = new Map();
  for (const row of rows) {
    if (!byEmail.has(row.managerEmail)) {
      byEmail.set(row.managerEmail, { email: row.managerEmail, name: row.managerName, rows: [] });
    }
    byEmail.get(row.managerEmail).rows.push(row);
  }
  return [...byEmail.values()].sort((a, b) => a.name.localeCompare(b.name, 'he'));
};
